/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import { getRoutes } from 'app-router';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const Root = () => {
	const routes = getRoutes();

	const router = createBrowserRouter(routes);

	return <RouterProvider router={router} />;
};
export default Root;
